/**
 * Mobile sticky ATC bar: show when scrolled past main ATC button, sync quantity and variant.
 */
(function () {
  function initStickyBar() {
    const bars = document.querySelectorAll('.product-sticky-atc-bar[data-section-id]');
    bars.forEach(function (bar) {
      initOneStickyBar(bar);
    });
  }

  function initOneStickyBar(bar) {
    if (bar.dataset.stickyBarMoved === 'true') return;

    const sectionId = bar.dataset.sectionId;
    const atcButtonId = bar.dataset.atcButtonId;
    const mainForm = document.getElementById(bar.dataset.productFormId);
    const mainQtyInput = document.getElementById('Quantity-' + sectionId);
    const stickyQtyInput = document.getElementById('Quantity-sticky-' + sectionId);
    const mainQtyInputWrapper = mainQtyInput?.closest('quantity-input');
    const stickyQtyInputWrapper = stickyQtyInput?.closest('quantity-input');
    const stickyAtcText = bar.querySelector('[data-sticky-atc-text]');
    const stickyVariantTitle = bar.querySelector('[data-sticky-variant-title]');
    const stickySubmitBtn = bar.querySelector('[data-sticky-atc-button]');

    if (!mainForm || !stickyQtyInput) return;

    // Move bar to body so position:fixed is relative to viewport, not a transformed ancestor
    document.body.appendChild(bar);
    bar.dataset.stickyBarMoved = 'true';

    const atcButton = document.getElementById(atcButtonId);

    // Show bar when ATC button scrolls out of view (above viewport)
    function observeAtcButton() {
      if (!atcButton) return;
      const observer = new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          if (!e) return;
          if (e.intersectionRatio > 0) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            // Only show if user has scrolled past initial viewport to prevent premature visibility on page load
            if (window.pageYOffset > 200 || window.scrollY > 200) {
              bar.hidden = false;
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          }
        },
        { root: null, rootMargin: '0px', threshold: 0 }
      );
      observer.observe(atcButton);
    }

    // Get current price text from product info (bar may be in body, so find via main form)
    function getPriceFromDom() {
      const productInfo = mainForm.closest('product-info');
      if (!productInfo) return '';
      
      // First check for atc-price-display in the submit button (variant-b-009 test)
      let priceEl = productInfo.querySelector('.product-form__submit .atc-price-display');
      
      // Fallback to standard price elements if not found
      if (!priceEl) {
        const salePrice = productInfo.querySelector('.price .price__sale .price-item--sale');
        const regularPrice = productInfo.querySelector('.price .price__regular .price-item--regular');
        priceEl = salePrice || regularPrice;
      }
      
      return priceEl ? priceEl.textContent.trim() : '';
    }

    // Sync main quantity -> sticky quantity
    function mainToStickyQty() {
      if (!mainQtyInput || !stickyQtyInput) return;
      const v = mainQtyInput.value;
      if (stickyQtyInput.value !== v) {
        stickyQtyInput.value = v;
        stickyQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        stickyQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        // Trigger validation on the quantity-input wrapper if it exists
        if (stickyQtyInputWrapper && typeof stickyQtyInputWrapper.validateQtyRules === 'function') {
          stickyQtyInputWrapper.validateQtyRules();
        }
      }
    }

    // Sync sticky quantity -> main quantity (so form submit uses correct qty)
    function stickyToMainQty() {
      if (!mainQtyInput || !stickyQtyInput) return;
      const v = stickyQtyInput.value;
      if (mainQtyInput.value !== v) {
        mainQtyInput.value = v;
        mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        // Trigger validation on the quantity-input wrapper if it exists
        if (mainQtyInputWrapper && typeof mainQtyInputWrapper.validateQtyRules === 'function') {
          mainQtyInputWrapper.validateQtyRules();
        }
      }
    }

    // Listen on both input elements AND their parent quantity-input wrappers
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', mainToStickyQty);
      mainQtyInput.addEventListener('input', mainToStickyQty);
    }
    if (mainQtyInputWrapper) {
      mainQtyInputWrapper.addEventListener('change', mainToStickyQty);
    }
    
    stickyQtyInput.addEventListener('change', stickyToMainQty);
    stickyQtyInput.addEventListener('input', stickyToMainQty);
    if (stickyQtyInputWrapper) {
      stickyQtyInputWrapper.addEventListener('change', stickyToMainQty);
    }

    // Add MutationObserver to detect value changes that don't trigger events
    if (mainQtyInput) {
      const mainQtyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            mainToStickyQty();
          }
        });
      });
      mainQtyObserver.observe(mainQtyInput, { attributes: true, attributeFilter: ['value'] });
      
      // Also watch for direct property changes using a polling mechanism as backup
      let lastMainValue = mainQtyInput.value;
      setInterval(function() {
        if (mainQtyInput.value !== lastMainValue) {
          lastMainValue = mainQtyInput.value;
          mainToStickyQty();
        }
      }, 100);
    }

    if (stickyQtyInput) {
      const stickyQtyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            stickyToMainQty();
          }
        });
      });
      stickyQtyObserver.observe(stickyQtyInput, { attributes: true, attributeFilter: ['value'] });
      
      // Also watch for direct property changes using a polling mechanism as backup
      let lastStickyValue = stickyQtyInput.value;
      setInterval(function() {
        if (stickyQtyInput.value !== lastStickyValue) {
          lastStickyValue = stickyQtyInput.value;
          stickyToMainQty();
        }
      }, 100);
    }

    // Intercept sticky button click and trigger main button instead
    if (stickySubmitBtn) {
      stickySubmitBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Sync quantity first
        stickyToMainQty();
        
        // Trigger the main ATC button click (preserves all behaviors/animations)
        const mainSubmitBtn = document.getElementById(atcButtonId);
        if (mainSubmitBtn) {
          mainSubmitBtn.click();
        }
      });
    }
    
    // Before submit from sticky, ensure main form has sticky quantity (fallback)
    mainForm.addEventListener('submit', function (e) {
      if (bar.contains(document.activeElement) || (e.submitter && bar.contains(e.submitter))) {
        stickyToMainQty();
      }
    });

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        if (event?.data?.sectionId !== sectionId) return;
        const html = event.data.html;
        const variant = event.data.variant;

        requestAnimationFrame(function () {
          const priceText = getPriceFromDom();
          const atcLabel = (typeof window.variantStrings !== 'undefined' && window.variantStrings?.addToCart) || 'Add to cart';
          if (stickyAtcText) {
            stickyAtcText.textContent = priceText ? atcLabel + ' · ' + priceText : atcLabel;
          }
          if (stickyVariantTitle && variant) {
            var standardIds = (bar.dataset.standardVariantIds || '').split(',').filter(Boolean);
            var valueIds = (bar.dataset.valueVariantIds || '').split(',').filter(Boolean);
            var idStr = String(variant.id);
            if (standardIds.indexOf(idStr) !== -1) stickyVariantTitle.textContent = 'Standard';
            else if (valueIds.indexOf(idStr) !== -1) stickyVariantTitle.textContent = 'Value Pack';
            else stickyVariantTitle.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : '';
          }
          if (stickySubmitBtn && variant) {
            const unavailable = !variant.available || variant.id == null;
            stickySubmitBtn.disabled = unavailable;
            stickySubmitBtn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
            if (unavailable && window.variantStrings?.soldOut) {
              stickyAtcText.textContent = window.variantStrings.soldOut;
            }
          }
          if (stickyQtyInput && variant?.quantity_rule) {
            const q = variant.quantity_rule;
            stickyQtyInput.setAttribute('min', q.min);
            stickyQtyInput.setAttribute('step', q.increment);
            if (q.max != null) stickyQtyInput.setAttribute('max', q.max);
            else stickyQtyInput.removeAttribute('max');
            stickyQtyInput.value = q.min;
            // Sync from main to sticky after variant change
            setTimeout(function() {
              mainToStickyQty();
            }, 50);
          }
        });
      });
    }

    // Initial sync
    mainToStickyQty();
    
    // Get initial price and set it
    const initialPrice = getPriceFromDom();
    const initialAtcLabel = (typeof window.variantStrings !== 'undefined' && window.variantStrings?.addToCart) || 'Add to cart';
    if (stickyAtcText) {
      stickyAtcText.textContent = initialPrice ? initialAtcLabel + ' · ' + initialPrice : initialAtcLabel;
    }
    
    // Watch the main submit button for price changes from component-atc-price-display
    const mainSubmitBtn = document.getElementById(atcButtonId);
    if (mainSubmitBtn && stickyAtcText) {
      const priceObserver = new MutationObserver(function() {
        const updatedPrice = getPriceFromDom();
        if (updatedPrice) {
          stickyAtcText.textContent = initialAtcLabel + ' · ' + updatedPrice;
        }
      });
      priceObserver.observe(mainSubmitBtn, { 
        childList: true, 
        subtree: true, 
        characterData: true 
      });
    }
    
    // Re-check price after delay to catch dynamically added price displays (like component-atc-price-display)
    setTimeout(function() {
      const delayedPrice = getPriceFromDom();
      if (delayedPrice && stickyAtcText) {
        stickyAtcText.textContent = initialAtcLabel + ' · ' + delayedPrice;
      }
    }, 1000);
    
    // Listen for variant/plan changes (variant-b-009 test uses radio buttons)
    if (mainForm.closest('product-info')) {
      const productInfo = mainForm.closest('product-info');
      const radioButtons = productInfo.querySelectorAll('.plan-option input[type="radio"]');
      radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function() {
          setTimeout(function() {
            const newPrice = getPriceFromDom();
            if (newPrice && stickyAtcText) {
              stickyAtcText.textContent = initialAtcLabel + ' · ' + newPrice;
            }
          }, 100);
        });
      });
    }
    
    // Delay observer setup to avoid race condition with async scripts (e.g., intelligems) modifying ATC button
    setTimeout(function() {
      observeAtcButton();
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBar);
  } else {
    initStickyBar();
  }
  document.addEventListener('shopify:section:load', initStickyBar);
})();
